// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2BzGw","upload":"Small_upload__stvTQ","imageWrap":"Small_imageWrap__e8jZx","removeBtn":"Small_removeBtn__1eera"};